import { Tree } from 'antd';

export default Tree;
